/**
 * Round 139 (owner ruling 2026-10-24) - while the learner's account is scheduled for deletion, every learner API answers 403
 * ACCOUNT_PENDING_DELETION (backend: src/services/deletionGate.ts). `apiFetch` announces it with this window event so ONE app-level screen
 * (components/account/PendingDeletionScreen.tsx) can offer "Keep my account" whichever page made the call.
 */
export const PENDING_DELETION_EVENT = 'emi:account-pending-deletion';

export interface PendingDeletionDetail { purgeAfter: string | null; canCancel: boolean }

export function notifyPendingDeletion(data: unknown): void {
  if (typeof window === 'undefined') return;
  const d = (data ?? {}) as { purgeAfter?: unknown; canCancel?: unknown };
  const detail: PendingDeletionDetail = { purgeAfter: typeof d.purgeAfter === 'string' ? d.purgeAfter : null, canCancel: d.canCancel === true };
  window.dispatchEvent(new CustomEvent<PendingDeletionDetail>(PENDING_DELETION_EVENT, { detail }));
}

/** Six calendar months from `from`, as the server counts the grace period (accountPurge.service.ts purgeAfterOf). */
export function sixMonthsFrom(from: Date): Date {
  const d = new Date(from.getTime());
  d.setUTCMonth(d.getUTCMonth() + 6);
  return d;
}
